<template>
  <DataTable
    data-testid="applied-allocation-table"
    :columns="columnsTable"
    :data="tableData"
    show-divider
    :has-interaction="false"
    :status="tableStatus"
    @on-sort="sortTable"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import { DataTable, DataTableProps } from '@warrenbrasil/nebraska-web';
import { columns } from './columns';
import {
  getAppliedAllocation,
  IAppliedItems
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  appliedTable: IAppliedItems[];
  portfolioId: string;
}
const { appliedTable, portfolioId } = defineProps<Props>();

const tableData = ref(appliedTable);
const isLoading = ref(false);

const productsLength = computed(() => {
  return appliedTable.length;
});

const columnsTable = computed(() => {
  return columns(productsLength.value);
});

const tableStatus = computed(() => {
  return isLoading.value
    ? DataTableProps.DataTableStatus.Loading
    : DataTableProps.DataTableStatus.Default;
});

async function sortTable(index: number, isSort: boolean, value: string) {
  isLoading.value = true;

  try {
    const direction = isSort ? 'Ascending' : 'Descending';
    const orderBy = index === -1 ? undefined : value;
    const orderType = index === -1 ? undefined : direction;

    const params = { orderBy, orderType };

    const data = await getAppliedAllocation(portfolioId, params);

    tableData.value = data.items;
  } finally {
    isLoading.value = false;
  }
}
</script>

<style lang="less" scoped>
:deep(.show-divider&:last-of-type > td) {
  border-bottom: none !important;
}
</style>
